// import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { OfferState } from "@/types/offer";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";
import { Offer } from "@/models/offer";

const state: OfferState = {
  single: new Offer(),
  pagination: new Pagination(),
};

export const offer: Module<OfferState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
